module.exports = __webpack_public_path__ + "img/six-14.cb777002.png";